module.exports = __webpack_public_path__ + "static/media/solo-scritta-bianca.fc60f1a3.svg";